import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useMemo } from "react";
import { useConfigurations } from "@via/api/configuration.tsx";
import { Spinner } from "@via/components/loading/loading";

export const StripeProvider = ({
  children,
  clientSecret,
}: {
  children: React.ReactNode;
  clientSecret: string;
}) => {
  const { data: config } = useConfigurations();

  const stripePromise = useMemo(() => {
    if (config?.ENABLE_STRIPE && config?.STRIPE_PUBLISHABLE_KEY) {
      return loadStripe(config.STRIPE_PUBLISHABLE_KEY);
    }
    return null;
  }, [config]);

  // If Stripe is disabled, we don't need a clientSecret or stripePromise, just render children
  if (config && !config.ENABLE_STRIPE) {
    return <>{children}</>;
  }

  // If config is not loaded yet or Stripe is enabled but missing requirements, show spinner
  if (!config || !stripePromise || !clientSecret) return <Spinner loading />;

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      {children}
    </Elements>
  );
};
